"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMenuItem = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('NavigationMenuItem'), recompose_1.pure);
var NavigationMenuItemPureComponent = function (props) {
    return !props.disabled && props.to ? (React.createElement(react_router_dom_1.NavLink, { className: classNames('sok-navigation-menu-item', props.className), to: props.to, exact: props.exact, isActive: function () {
            if (props.isActive !== undefined) {
                return props.isActive();
            }
            if (props.exact) {
                if (props.to === window.location.pathname) {
                    return true;
                }
            }
            else if (window.location.pathname.startsWith(props.to)) {
                return true;
            }
            return false;
        } },
        React.createElement("span", { className: "sok-navigation-menu-item-icon" }, props.icon),
        React.createElement("span", { className: "sok-navigation-menu-item-text" }, props.text))) : (React.createElement("div", { className: classNames('sok-navigation-menu-item', props.disabled && 'disabled', props.className), onClick: !props.disabled ? function (e) { return props.onClick(e); } : undefined },
        React.createElement("span", { className: "sok-navigation-menu-item-icon" }, props.icon),
        React.createElement("span", { className: "sok-navigation-menu-item-text" }, props.text)));
};
exports.NavigationMenuItem = enhance(NavigationMenuItemPureComponent);
//# sourceMappingURL=index.js.map